<div
    class="relative flex items-center gap-4 p-2 px-4 rounded-md transition duration-200 cursor-pointer user-menu"
    role="button"
    tabindex="0"
    aria-label="User menu"
    (click)="isUserMenuVisible.set(!isUserMenuVisible())"
    (keydown.enter)="isUserMenuVisible.set(!isUserMenuVisible())"
    [class.bg-gray-100]="isUserMenuVisible()"
>
    <div
        class="flex justify-center items-center !bg-orange-400 hover:bg-gray-800 mt-0 rounded-full !outline-none w-[30px] h-[30px] font-bold text-white cursor-pointer"
    >
        <span class="cursor-pointer" tabindex="0">
            {{ userInfo()?.firstName?.charAt(0) || 'U' }}{{ userInfo()?.lastName?.charAt(0) || 'N' }}
        </span>
    </div>

    <div class="items-center gap-0 grid w-[120px]">
        <div>{{ userInfo()?.firstName }} {{ userInfo()?.lastName }}</div>
        <div class="w-[100px] overflow-hidden text-gray-500 text-xs text-ellipsis whitespace-nowrap">
            {{ userInfo()?.username }}
        </div>
    </div>

    <i
        class="top-1/2 right-2 absolute opacity-40 transition-transform -translate-y-1/2 duration-200 pi pi-angle-down transform"
        [class.rotate-180]="isUserMenuVisible()"
    ></i>
</div>

@if (isUserMenuVisible()) {
    <div
        class="top-17 right-[-5px] absolute bg-white dark:bg-gray-800 shadow-lg p-2 py-2 border border-gray-200 dark:border-gray-700 rounded-md w-[240px] cursor-default user-dropdown-menu"
    >
        <div class="top-1 right-1 absolute">
            <!-- <app-theme-toggle /> -->
        </div>

        <div class="mb-2 px-2 py-1">
            <div class="flex items-center gap-1 text-gray-400">
                <span class="mt-1 text-[10px]"> ORG </span>
                <strong>
                    {{ userInfo()?.tenant?.organizationAlias }}
                </strong>
            </div>
        </div>

        <div class="mb-2 border-gray-100 dark:border-gray-600 border-b"></div>

        @for (item of userItems(); track $index) {
            <a
                class="block flex items-center gap-2 hover:bg-gray-200 dark:hover:bg-gray-600 px-2 py-2 rounded-md hover:text-gray-700 dark:hover:text-gray-200 cursor-pointer"
                (click)="goTo(item.routerLink)"
                (keydown.enter)="goTo(item.routerLink)"
                tabindex="0"
                role="button"
            >
                {{ item.label }}
            </a>
        }
        <a
            class="block flex items-center gap-2 hover:bg-gray-100 dark:hover:bg-gray-500 px-2 py-2 rounded-md text-red-500 dark:hover:text-gray-100 cursor-pointer"
            (click)="logout()"
            (keydown.enter)="logout()"
            tabindex="0"
            role="button"
        >
            <i class="!text-sm pi pi-sign-out"></i>
            Logout
        </a>
    </div>
}
